import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Users } from '@sorare/core/src/atoms/icons/Users';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { glossary } from '@sorare/core/src/lib/glossary';

import { InviteButtonFTUE } from '../InviteButtonFTUE';
import { InviteDialog } from '../InviteDialog';

const StyledButton = styled(Button)`
  border: 1px solid var(--c-set-surface-primary);
  background: linear-gradient(
    323deg,
    rgba(var(--c-rgb-set-surface-primary), 0.1) 14.3%,
    rgba(var(--c-rgb-set-surface-primary-text), 0.1) 85.7%
  );
  backdrop-filter: blur(2px);
`;

export const InviteButton = () => {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

  return (
    <>
      <OnboardingHighlightWrapper
        highlightName="InviteButton"
        config={{ padding: 4, borderRadius: 'var(--unit)' }}
      >
        <StyledButton
          size="compact"
          color="quaternary"
          onClick={() => {
            setInviteDialogOpen(true);
          }}
          startIcon={<Users />}
        >
          <FormattedMessage {...glossary.invite} />
        </StyledButton>
      </OnboardingHighlightWrapper>
      <InviteButtonFTUE />
      {!!inviteDialogOpen && (
        <InviteDialog
          open
          onClose={() => {
            setInviteDialogOpen(false);
          }}
        />
      )}
    </>
  );
};
